import { initializeApp } from 'firebase/app';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

// Modern persistence API. Replaces the deprecated enableIndexedDbPersistence
// which fell back to memory cache on multi-tab and forced a full Firestore
// re-fetch on every cold load. The multi-tab manager keeps IndexedDB shared
// across tabs (DM laptop + display TV + player phones, same browser),
// staying offline-resilient without any of them losing the cache.
// Must be the FIRST Firestore call in the app.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

export const storage = getStorage(app);

export const CAMPAIGN_ID = import.meta.env.VITE_CAMPAIGN_ID || 'default-campaign';
